function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("g", null, React.createElement("polygon", {
  points: "85.877,154.014 85.877,428.309 131.706,428.309 131.706,154.014 180.497,221.213 217.584,194.27 108.792,44.46  0,194.27 37.087,221.213  "
}), React.createElement("polygon", {
  points: "404.13,335.988 404.13,61.691 358.301,61.691 358.301,335.99 309.503,268.787 272.416,295.73 381.216,445.54  490,295.715 452.913,268.802  "
}));
const SvgSortingIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return React.createElement("svg", _extends({
    fill: "#000000",
    height: 13,
    width: 12,
    id: "Capa_1",
    viewBox: "0 0 490 490",
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, _ref2);
};
const ForwardRef = React.forwardRef((props, ref) => React.createElement(SvgSortingIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/sorting-icon.f01e7e10.svg";
export { ForwardRef as ReactComponent };